import Stack from '@admin/components/stack'
import Downloading from './downloading'
import PropTypes from 'prop-types'
import Browser from './browser'
import Profile from './profile'
import React from 'react'

class CanvaImport extends React.Component {

  static propTypes = {
    root: PropTypes.object,
    onBack: PropTypes.func,
    onDone: PropTypes.func
  }

  stackRef = React.createRef()

  _handleBrowser = this._handleBrowser.bind(this)
  _handleDone = this._handleDone.bind(this)
  _handleDownloading = this._handleDownloading.bind(this)

  render() {
    return <Stack { ...this._getStack()} />
  }

  componentDidMount() {
    this._handleProfile()
  }

  _getStack() {
    return {
      display_name: 'canva browser',
      ref: this.stackRef
    }
  }

  _handleDone(social_campaign) {
    this.stackRef.current.pop(1)
    this.props.onDone({
      assets: social_campaign.assets,
      profile: social_campaign.profile,
      design: social_campaign.design
    })
  }

  _handlePop(index = -1) {
    this.stackRef.current.pop(index)
  }

  _handleBrowser(profile) {
    const { root, onBack } = this.props
    this._handlePush(Browser, {
      profile,
      root,
      onBack,
      onDone: this._handleDownloading
    })
  }

  _handleDownloading({ profile, design }) {
    this._handlePush(Downloading, {
      profile,
      design,
      onDone: this._handleDone
    })
  }

  _handleProfile() {
    const { onBack } = this.props
    this._handlePush(Profile, {
      onBack,
      onDone: this._handleBrowser
    })
  }

  _handlePush(component, props) {
    this.stackRef.current.push({ component, props })
  }

}

export default CanvaImport

